/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateSharedWorkspaceRequest } from '../../models/update-shared-workspace-request';
import { UpdateSharedWorkspaceResponse } from '../../models/update-shared-workspace-response';

export interface UpdateSharedWorkspace$Params {

/**
 * Workspace ID
 */
  workspaceId: number;
  
    /**
     * Workspace update data
     */
    body?: UpdateSharedWorkspaceRequest
}

export function updateSharedWorkspace(http: HttpClient, rootUrl: string, params: UpdateSharedWorkspace$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateSharedWorkspaceResponse>> {
  const rb = new RequestBuilder(rootUrl, updateSharedWorkspace.PATH, 'patch');
  if (params) {
    rb.path('workspaceId', params.workspaceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateSharedWorkspaceResponse>;
    })
  );
}

updateSharedWorkspace.PATH = '/workspaces/shared/{workspaceId}';
